import React, {FC, useState, useEffect, useCallback} from 'react'
import {Dropdown, FormControl} from 'react-bootstrap'
import {getInstitutionSuggestions} from '../core/_requests'
import debounce from 'lodash/debounce'
import clsx from 'clsx'

type AutocompleteInputProps = {
  field: 'institution_name' | 'institution_category'
  placeholder: string
  value: string
  onChange: (value: string) => void
  onBlur: (e: any) => void
  isInvalid: boolean
  isValid: boolean
}

const AutocompleteInput: FC<AutocompleteInputProps> = ({
  field,
  placeholder,
  value,
  onChange,
  onBlur,
  isInvalid,
  isValid,
}) => {
  const [suggestions, setSuggestions] = useState<string[]>([])
  const [showDropdown, setShowDropdown] = useState(false)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fetchSuggestions = useCallback(
    debounce(async (query: string) => {
      if (query.length < 2) {
        setSuggestions([])
        setShowDropdown(false)
        return
      }

      try {
        const res = await getInstitutionSuggestions(field, query)
        setSuggestions(res.data.suggestions)
        setShowDropdown(res.data.suggestions.length > 0)
      } catch (error) {
        console.error('Error fetching suggestions:', error)
      }
    }, 300),
    [field]
  )

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    onChange(newValue)
    fetchSuggestions(newValue)
  }

  const handleSelect = (suggestion: string) => {
    onChange(suggestion)
    setShowDropdown(false)
  }

  return (
    <div className='position-relative'>
      <input
        placeholder={placeholder}
        type='text'
        autoComplete='off'
        value={value}
        onChange={handleInputChange}
        onBlur={(e) => {
          onBlur(e)
          // Small timeout to allow click on dropdown items
          setTimeout(() => setShowDropdown(false), 200)
        }}
        className={clsx('form-control bg-transparent', {
          'is-invalid': isInvalid,
          'is-valid': isValid,
        })}
      />
      {showDropdown && suggestions.length > 0 && (
        <ul
          className='dropdown-menu show w-100'
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            zIndex: 1000,
            maxHeight: '200px',
            overflowY: 'auto',
          }}
        >
          {suggestions.map((suggestion, index) => (
            <li key={index}>
              <button
                className='dropdown-item'
                type='button'
                onClick={() => handleSelect(suggestion)}
              >
                {suggestion}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default AutocompleteInput
